<template>
  <div class="page">
    <!-- 搜索 -->
    <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small"
      class="query-form" @submit.native.prevent>
      <el-form-item label="日志类型">
        <el-input style="width: 177px;" v-model="queryForm.logType"></el-input>
      </el-form-item>
      <el-form-item label="目标">
        <el-input style="width: 177px;" v-model="queryForm.targetId"></el-input>
      </el-form-item>
      <el-form-item label="用户">
        <!-- <el-input  v-model="queryForm.userId"></el-input> -->
        <GridSelectU title="选择用户" style="width: 177px;" labelName="userName" labelValue="id" :value="queryForm.userId" :limit='1'
          size='small' placeholder='请选择用户' @getValue="getSeachValuebrandId" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
        </GridSelectU>
      </el-form-item>
      <el-form-item label="IP地址">
        <el-input style="width: 177px;" v-model="queryForm.ipAddress"></el-input>
      </el-form-item>
      <el-form-item label="IP所在位置">
        <el-input style="width: 177px;" v-model="queryForm.ipPlace"></el-input>
      </el-form-item>
      <el-form-item label="日志内容">
        <el-input style="width: 177px;" v-model="queryForm.logContent"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="getMppLogOperateList">查询</el-button>
        <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
      </el-form-item>
    </el-form>
    <div class="page-content">
      <div class="page-tool-bar">
        <div class="el-btn-group">
          <!-- <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addMppLogOperate"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editMppLogOperate(null)"
        >修改</el-button> -->
          <el-button type="danger" plain size="small" icon="el-icon-delete" :disabled="multipleSelection.length <= 0"
            @click="deleteMppLogOperate(null)">删除</el-button>
        </div>

        <div class="icon-group">
          <el-upload v-if="this.isImportDate" class="upload-demo" action="#" :http-request="upload"
            :show-file-list="true">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
          </el-upload>
          <span title="搜索" class="icon-box" @click="search">
            <Icon color="#606266">
              <Search />
            </Icon>
          </span>
          <!-- <span title="下载模板" class="icon-box" @click="importTemplate">
            <Icon color="#606266">
              <ArrowDown />
            </Icon>
          </span>
          <span class="icon-box" title="导入数据" @click="isImport">
            <Icon color="#606266">
              <ArrowExportUp24Regular />
            </Icon>
          </span>
          <span title="导出数据" class="icon-box" @click="exportMppLogOperateList">
            <Icon color="#606266">
              <ArrowDownload24Regular />
            </Icon>
          </span> -->
          <span class="icon-box" @click="refreshMppLogOperateList">
            <Icon color="#606266">
              <Refresh />
            </Icon>
          </span>
        </div>
      </div>
      <!-- 列表数据 -->
      <el-table :data="mppLogOperateList" row-key="id" border height="100%" :header-row-style="{ height: '10px' }"
        :header-cell-style="{ padding: '10px' }" :row-style="{ height: '9px' }" :cell-style="{ padding: '9px' }"
        @selection-change="handleSelectionChange" size="small">
        <el-table-column align="center" type="selection" width="60"> </el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" prop="logType" label="日志类型">
          <template slot-scope="scope">
            {{ getPacketType(scope.row.logType) }}
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" prop="targetId" label="目标">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" prop="userId" label="用户">
          <template slot-scope="scope">
            <div v-if="scope.row.user">
                <div style="text-align: left">账号：{{ scope.row.user.userName }}</div>
                <div style="text-align: left">手机：{{ scope.row.user.userMobile }}</div>
                <div style="text-align: left">昵称：{{ scope.row.user.userNickname }}</div>
                <div style="text-align: left">姓名：{{ scope.row.user.userRealname }}</div>
            </div>
            <div v-else>--</div>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" prop="ipAddress" label="IP地址">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" prop="ipPlace" label="IP所在位置">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" prop="logContent" label="日志内容">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" prop="createTime" label="创建时间">
        </el-table-column>
        <el-table-column fixed="right" align="center" label="操作" width="200">
          <template slot-scope="scop">
            <div class="operation">
              <div @click="checkMppLogOperate(scop.row.id)">
                <Icon size="16">
                  <Eye24Regular />
                </Icon>
                <span class="operation-label">查看</span>
              </div>
              <!-- <div @click="editMppLogOperate(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div> -->
              <div @click="deleteMppLogOperate(scop.row.id)">
                <Icon size="16" style="color: red">
                  <Delete24Regular />
                </Icon>
                <span class="operation-label" style="color: red">删除</span>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-box">
        <el-pagination @size-change="sizeChange" @current-change="currentChange" :current-page.sync="currentPage"
          :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum" background :pager-count="7">
        </el-pagination>
      </div>
      <!-- 新增/查看/修改信息 -->
      <el-dialog :title="mppLogOperateStates[mppLogOperateState]" :visible.sync="showDialog" width="60%"
        @close="closeDialog">
        <div>
          <el-form :model="mppLogOperate" ref="mppLogOperateForm" :rules="rules" label-width="120px" :inline="true"
            size="small">
            <el-form-item label="日志类型" prop="logType">
              <el-input style='width: 177px;' size="small" v-model="mppLogOperate.logType" :disabled="mppLogOperateState == 'check'"></el-input>
            </el-form-item>
            <el-form-item label="目标" prop="targetId">
              <el-input style='width: 177px;' size="small" v-model="mppLogOperate.targetId"
                :disabled="mppLogOperateState == 'check'"></el-input>
            </el-form-item>
            <el-form-item label="用户" prop="userId">
              <!-- <el-input
              size="small"
              v-model="mppLogOperate.userId"
              :disabled="mppLogOperateState == 'check'"
            ></el-input> -->
              <GridSelectU title="选择用户" style="width: 177px;" labelName="userName" :disabled="mppLogOperateState == 'check'"
                labelValue="id" :value="mppLogOperate.userId" :limit='1' size='small' placeholder='请选择用户'
                @getValue="getValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
              </GridSelectU>
            </el-form-item>
            <el-form-item label="IP地址" prop="ipAddress">
              <el-input style='width: 177px;' size="small" v-model="mppLogOperate.ipAddress"
                :disabled="mppLogOperateState == 'check'"></el-input>
            </el-form-item>
            <el-form-item label="IP所在位置" prop="ipPlace">
              <el-input style='width: 177px;' size="small" v-model="mppLogOperate.ipPlace" :disabled="mppLogOperateState == 'check'"></el-input>
            </el-form-item>
            <el-form-item label="日志内容" prop="logContent">
              <el-input style='width: 177px;' size="small" v-model="mppLogOperate.logContent"
                :disabled="mppLogOperateState == 'check'"></el-input>
            </el-form-item>
            <el-form-item label="创建时间" prop="createTime" v-show="mppLogOperateState == 'check'">
              <el-input style='width: 177px;' size="small" v-model="mppLogOperate.createTime"
                :disabled="mppLogOperateState == 'check'"></el-input>
            </el-form-item>
          </el-form>
        </div>

        <div slot="footer" class="flex justify-end">
          <el-button @click="closeDialog">关闭</el-button>
          <el-button type="primary" @click="submitForm" v-if="mppLogOperateState != 'check'">确定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import GridSelectU from '@/components/gridselect';
import { USER, USER_SEARCH } from '@/utils/constant'
export default {
  components: {
    Edit24Regular,
    Delete24Regular,
    Eye24Regular,
    GridDots,
    Refresh,
    Printer,
    ArrowUp,
    ArrowDown,
    ArrowDownload24Regular,
    ArrowExportUp24Regular,
    Search,
    GridSelectU
  },
  watch: {
    checkState(val) {
      if (val == 'check') {
        this.resetMppLogOperateList();
        this.getMppLogOperateList(this.queryForm);
        this.$emit('resetCheckState');
      } else if (val == 'reset') {
        this.resetMppLogOperateList();
        this.getMppLogOperateList();
        this.$emit('resetCheckState');
      }
    }
  },
  data() {
    return {
      USER_code: USER,
      USER_search: USER_SEARCH,
      queryForm: {
        id: '', //ID
        logType: '', //日志类型
        targetId: '', //目标ID
        userId: '', //用户ID
        ipAddress: '', //IP地址
        ipPlace: '', //IP所在位置
        logContent: '', //日志内容
        createTime: '', //创建时间
      },
      loading: false,
      showDialog: false,
      isImportDate: false,
      isSearch: false,
      pageSize: 10,
      currentPage: 1,
      totalNum: 0,
      currentUserId: '',
      mppLogOperateState: 'add',
      mppLogOperateStates: {
        add: '新建日志',
        check: '查看日志',
        edit: '修改日志'
      },
      GetmppLogOperateEumn: [],
      multipleSelection: [],
      mppLogOperateList: [],
      mppLogOperate: {
        id: '', //ID
        logType: '', //日志类型
        targetId: '', //目标ID
        userId: '', //用户ID
        ipAddress: '', //IP地址
        ipPlace: '', //IP所在位置
        logContent: '', //日志内容
        createTime: '', //创建时间
      },
      btnLoading: false,

      rules: {
        id: [{ required: true, message: 'ID不能为空', trigger: 'blur' }],
        logType: [{ required: true, message: '日志类型不能为空', trigger: 'blur' }],
        targetId: [{ required: true, message: '目标ID不能为空', trigger: 'blur' }],
        userId: [{ required: true, message: '用户ID不能为空', trigger: 'blur' }],
        ipAddress: [{ required: true, message: 'IP地址不能为空', trigger: 'blur' }],
        ipPlace: [{ required: true, message: 'IP所在位置不能为空', trigger: 'blur' }],
        logContent: [{ required: true, message: '日志内容不能为空', trigger: 'blur' }],
        createTime: [{ required: true, message: '创建时间不能为空', trigger: 'blur' }],
      }
    };
  },
  created() {
    this.getMppLogOperateList();
    this.getEumn();
  },
  methods: {
    getEumn() {
      get('/mpp/utils/getEnum', { enumType: 'log_operate_type' }).then((res) => {
        if (res.success && res.code == 200) {
          this.GetmppLogOperateEumn = res.enumList;
        }
        console.log(this.GetmppLogOperateEumn)
      });
    },
    getPacketType(packetType) {
      for (const index in this.GetmppLogOperateEumn) {
        if (this.GetmppLogOperateEumn[index].key == packetType) {
          return this.GetmppLogOperateEumn[index].value;
        }
      }
    },
    getSeachValuebrandId(value) {
      this.queryForm.userId = value;
    },
    getValueUser(value) {
      this.mppLogOperate.userId = value
    },
    search() {
      this.isSearch = !this.isSearch;
    },
    resetMppLogOperateList() {
      this.pageSize = 10;
      this.currentPage = 1;
      this.mppLogOperateList = [];
    },
    resetDialog() {
      this.mppLogOperateState = 'add';
      this.showDialog = false;
      this.queryForm = {
        id: '', //ID
        logType: '', //日志类型
        targetId: '', //目标ID
        userId: '', //用户ID
        ipAddress: '', //IP地址
        ipPlace: '', //IP所在位置
        logContent: '', //日志内容
        createTime: '', //创建时间
      };
      this.getMppLogOperateList();
    },
    closeDialog() {
      this.showDialog = false
      this.mppLogOperate = {
        id: '', //ID
        logType: '', //日志类型
        targetId: '', //目标ID
        userId: '', //用户ID
        ipAddress: '', //IP地址
        ipPlace: '', //IP所在位置
        logContent: '', //日志内容
        createTime: '', //创建时间
      };
    },
    submitForm() {
      console.log(this.mppLogOperate);
      if (this.mppLogOperateState == 'add') {
        this.$refs.mppLogOperateForm.validate((valid) => {
          if (valid) {
            console.log('submit');
            post(`/mpp/logoperate/add`, { ...this.mppLogOperate }).then((res) => {
              if (res.success) {
                this.$message({
                  message: res.msg,
                  type: 'success',
                  duration: 2000,
                });
                this.resetMppLogOperateList();
                this.resetDialog();
              } else {
                this.$message({
                  message: res.msg,
                  type: 'error',
                  duration: 2000
                });
              }
            });
          }
        });
      } else if (this.mppLogOperateState == 'edit') {
        this.$refs.mppLogOperateForm.validate((valid) => {
          if (valid) {
            console.log('submit');
            post(`/mpp/logoperate/edit`, { ...this.mppLogOperate }).then((res) => {
              if (res.success) {
                this.$message({
                  message: res.msg,
                  type: 'success',
                  duration: 2000
                });
                this.resetMppLogOperateList();
                this.resetDialog();
              } else {
                this.$message({
                  message: res.msg,
                  type: 'error',
                  duration: 2000
                });
              }
            });
          }
        });
      }
    },
    addMppLogOperate() {
      this.showDialog = true;
      this.mppLogOperateState = 'add';
    },
    checkMppLogOperate(mppLogOperateId) {
      console.log(mppLogOperateId);
      this.currentMppLogOperateId = mppLogOperateId;

      this.getMppLogOperateById();
      this.showDialog = true;
      this.mppLogOperateState = 'check';
    },
    editMppLogOperate(mppLogOperateId) {
      console.log('mppLogOperate', mppLogOperateId);
      if (mppLogOperateId) {
        this.currentMppLogOperateId = mppLogOperateId;
        this.getMppLogOperateById();
      } else {
        this.mppLogOperate = { ...this.mppLogOperate, ...this.multipleSelection[0] };
      }

      this.showDialog = true;
      this.mppLogOperateState = 'edit';
    },
    deleteMppLogOperate(mppLogOperateId) {
      let ids = '';
      if (mppLogOperateId) {
        ids = mppLogOperateId;
      } else {
        ids = this.multipleSelection.map((mppLogOperate) => mppLogOperate.id).join(',');
      }
      console.log({ ids });
      this.$confirm('确定删除所选项吗？', '提示', {
        type: 'warning'
      })
        .then(() => {
          deleteFun(`/mpp/logoperate/delete`, { ids }).then((res) => {
            if (res.success) {
              this.$message({
                message: res.msg,
                type: 'success',
                duration: 2000
              });
              this.resetMppLogOperateList();
              this.getMppLogOperateList();
            } else {
              this.$message({
                message: res.msg,
                type: 'error',
                duration: 2000
              });
            }
          });
        })
        .catch(() => { });
    },
    refreshMppLogOperateList() {
      this.resetMppLogOperateList();
      this.getMppLogOperateList();
    },
    getMppLogOperateList(query = {}) {
      this.loading = true;
      get(`/mpp/logoperate/findList`, { ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
        this.loading = false;
        if (res.success) {
          this.mppLogOperateList = res.page.list;
          this.totalNum = res.page.total;
        } else {
          this.$message({
            message: res.msg,
            type: 'error',
            duration: 2000
          });
        }
      });
    },
    getMppLogOperateById() {
      get(`/mpp/logoperate/get`, { id: this.currentMppLogOperateId }).then((res) => {
        if (res.success) {
          this.mppLogOperate = { ...this.mppLogOperate, ...res.mppLogOperate };
        } else {
          this.$message({
            message: res.msg,
            type: 'error',
            duration: 2000
          });
        }
      });
    },
    /**
     * 导出信息
     */
    exportMppLogOperateList() {
      //this.btnLoading = true;
      exprotExcel(`/mpp/logoperate/export`, { ...this.queryForm });
    },
    /**
     * 导出模板
     */
    importTemplate() {
      this.btnLoading = true;
      importTemplate(`/mpp/logoperate/importTemplate`, this.btnLoading);
    },
    /**
     * 导入数据
     */
    isImport() {
      this.isImportDate = !this.isImportDate;
    },
    upload(params) {
      const file = params.file;
      const formData = new FormData();
      formData.append('file', file);
      console.log({ formData });
      importDate(`/mpp/logoperate/importData`, formData);
      this.refreshMppLogOperateList();
    },
    handleSelectionChange(value) {
      console.log(value);
      this.multipleSelection = value;
    },
    currentChange(page) {
      this.currentPage = page;
      this.getMppLogOperateList();
    },
    sizeChange(size) {
      this.pageSize = size;
      this.getMppLogOperateList();
    }
  }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.operation {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #409eff;
  font-size: 12px;

  &>div {
    display: flex;
    align-items: center;
    padding: 0 5px;
    cursor: pointer;
  }

  .operation-label {
    margin-left: 3px;
  }
}
</style>